import Api from "./Api";

const Cities = () => {
    return Api().get("/citys")
}

const City = (id) => {
    return Api().get(`/citys/${id}`)
}

const AddCity = (data) => {
    return Api().post("/citys", data)
}

const EditCity = (id, data) => {
    return Api().put(`/citys/${id}`, data)
}

const RemoveCity = (id) => {
    return Api().delete(`/citys/${id}`)
}

export { Cities, City, AddCity, EditCity, RemoveCity }